/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'top': {
    width: 4,
    height: 24,
    viewBox: '0 0 4 24',
    data: '<path pid="0" d="M0 12h3v12h1V0L0 12z"/>'
  }
})
